'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {getCollection} from '../../../core-utilities/domain/ReduxUtils';
import {AvatarColors} from '../../../core-utilities/domain/AvatarColors';
import {I18nMessage} from '../../../components/I18nMessage';
import {ListItem} from '../../../components/lists/ListItem';
import {AvatarImage} from '../../../files/components/AvatarImage';
import {getInitials} from './PeopleItemView';


export function PeopleItemViewSimple(props) {
  const model = props.model || {};
  const collection = getCollection(model);
  const hasValidName = props.showName && (model.name || props.nullLabel);
  const name = hasValidName ? (
    <h2>
      {model.name ? model.name : <I18nMessage message={props.nullLabel} />}
    </h2>
  ) : null;
  const Item = props.useListItem ? ListItem : 'div';

  return (
    <Item
      className={classNames(getClassName(props, "PeopleItemViewSimple"), props.className)}
      title={model.name ? model.name : void 0}
      onClick={props.onClick}
    >
      {props.rtl ? name : null}
      <AvatarImage
        className={getClassName(props, "PeopleItemViewSimple__avatar")}
        iconClass="Avatar__icon"
        avatarInitials={getInitials(collection, model.name)}
        avatarColor={AvatarColors.getColor(model.avc)}
        avatarFontColor={AvatarColors.getFontColor(model.avc)}
        url={model.avatar ? model.avatar.url : null}
        displayWidth={props.avatarImageWidth || 29}
        displayHeight={props.avatarImageHeight || 29}
        targetWidth={props.avatarImageWidth || 29}
        targetHeight={props.avatarImageHeight || 29}
      />
      {!props.isSelected ? null : (
        <i className={getClassName(props, "PeopleItemViewSimple__check")} />
      )}
      {!props.rtl ? name : null}
    </Item>
  );
}

function getClassName(props, className) {
  if (!props.showName) {
    return className;
  } else if (props.rtl) {
    return `${className}_rtl`;
  } else {
    return `${className}_ltr`;
  }
}

PeopleItemViewSimple.propTypes = {
  className: T.string,
  useListItem: T.bool,
  isSelected: T.bool,
  nullLabel: T.string,
  model: T.object,
  rtl: T.bool,
  showName: T.bool,
  onClick: T.func,
  avatarImageWidth: T.number,
  avatarImageHeight: T.number,
};

PeopleItemViewSimple.defaultProps = {
  className: '',
  useListItem: true,
  avatarImageWidth: null,
  avatarImageHeight: null,
};



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleItem/PeopleItemViewSimple.js